import { Role } from '../../../interfaces/account';

export enum ChannelType {
  CENTROCOMPENTENZA = 'CDC',
  //CONFIDI = 'CONFIDI',
  SGR = 'SGR',
  //ASSOCIAZIONI = 'ASSOCIAZIONI',
  //MEDIATORI = 'MEDIATORI',
  //SPV = 'SPV',
  AML = 'AML',
}

export const ROLERECORD: Record<ChannelType, Role[]> = {
  //ASSOCIAZIONI: ['Responsabile', 'Addetto'],
  CDC: ['Amministratore'],
  //CONFIDI: ['Responsabile', 'Addetto'],
  //MEDIATORI: ['Responsabile', 'Addetto'],
  SGR: ['Responsabile', 'Addetto', 'Fund manager'],
  //SPV: [],
  AML: ['Responsabile', 'Addetto', 'Autorizzatore', 'Funzione', 'Back office'],
};
